import styled from 'styled-components';

export const StyledSelectableButton = styled.div`
  background: transparent;
  width: ${({ theme }) => theme.selectableButtonSize};
  min-width: ${({ theme }) => theme.selectableButtonSize};
  height: ${({ theme }) => theme.selectableButtonSize};
  min-height: ${({ theme }) => theme.selectableButtonSize};
  cursor: ${({ $disabled }) => $disabled ? undefined : 'pointer'};
  position: relative;
  padding: ${({ theme }) => theme.buttonFrameWidth};
  z-index: ${({ $selected }) => $selected ? '200' : 'unset'};
  opacity: ${({ $disabled }) => $disabled ? '0.4' : '1.0'};

  &:hover {
    .selectable-button-corner {
      opacity: ${({ $disabled }) => $disabled ? '0.0' : '1.0' };
      border: solid ${({ theme }) => theme.buttonFrameWidth} ${({ theme, $selected, $disabled }) => $disabled ? 'transparent' : $selected ? theme.selection : 'white'};
    }

    .selectable-button-corner-l {
      border-right: none;
    }

    .selectable-button-corner-r {
      border-left: none;
    }
  }

  .selectable-button-content {
    background: ${({ theme, $selected, $backgroundOverwrite }) => $backgroundOverwrite ? $backgroundOverwrite : $selected ? theme.background : theme.buttonDark};
    border: solid ${({ theme }) => theme.buttonFrameWidth} ${({ theme, $borderOverwrite }) => $borderOverwrite ? $borderOverwrite : theme.borderDark};
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    transition: linear 0.2s;

    img {
      transition: linear 0.2s;
      width: ${({ $icon })=> $icon ? '50%' : '100%'};
      max-width: ${({ $icon })=> $icon ? '50%' : '100%'};
      height: ${({ $icon })=> $icon ? '50%' : '100%'};
      max-height: ${({ $icon })=> $icon ? '50%' : '100%'};
    }
  }

  .selectable-button-corner {
    transition: opacity linear 0.2s;
    border: solid ${({ theme }) => theme.buttonFrameWidth} ${({ theme, $selected }) => $selected ? theme.selection : 'white'};
    opacity: ${({ $selected }) => $selected ? '1.0' : '0.0'};
    position: absolute;
    top: 0;
    bottom: 0;
    width: 8px
  }

  .selectable-button-corner-l {
    border-right: none;
    left: 0;
  }

  .selectable-button-corner-r {
    border-left: none;
    right: 0;
  }
`;

